export const RepeatBlockDocumentationMarkdown = `
## What does this block do?

The Repeat Block executes a designated subflow repeatedly until a specified condition is met.

## When to use it?

Common use cases:
* To periodically check an external status until it is ready
* To load paginated data from an API until all the data has been retrieved

## How to configure this block?

1. In the **Subflow** section, specify the subflow to be run repeatedly. This is done the same way as in the Subflow block.

    * When configuring the subflow's inputs, references may use \`lastResult\` to access the output from the previous subflow run, if any.
    Similarly, \`index\` refers to the sequential order of the next subflow run, starting with zero for the first run.

2. In the **Condition** section, specify an "until" condition and a maximum number of iterations. 
   The subflow will be executed repeatedly until either the condition is met or the maximum is reached.

    * The "until" condition is a script expression to be evaluated before each subflow run. 
    When it is true, the repeating immediately stops.
    You can use the \`lastResult\` variable to access the output from the previous subflow run, 
    as well as \`index\` to access the next run's iteration index (e.g., one just after the first subflow run and before the second).
    For example, if the subflow's output includes a \`status\` field, an appropriate condition script might be:
    \`lastResult.status === 'COMPLETED'\`

    * The maximum number of iterations is required as a safety measure to prevent repeating forever and consuming costly resources.
    If the maximum is exceeded, this block will fail with an error. 

## Advanced Settings

Set **Time Interval** to a number of seconds/minutes/hours you'd like to pass between each iteration.
This delay happens just before each subflow run, except the first one, and just after the condition check.

## Output

This block returns an array of the outputs from the subflow runs.
`;
